/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvbGFudGFnby1hcHAvbGFudGFnby1hcHAtZGVtby9zcmMvYXBwL2F1dGgvcmVjb3Zlci1wYXNzd29yZC9yZWNvdmVyLXBhc3N3b3JkLWRvbmUvcmVjb3Zlci1wYXNzd29yZC1kb25lLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9sYW50YWdvLWFwcC9sYW50YWdvLWFwcC1kZW1vL3NyYy9hcHAvYXV0aC9yZWNvdmVyLXBhc3N3b3JkL3JlY292ZXItcGFzc3dvcmQtZG9uZS9yZWNvdmVyLXBhc3N3b3JkLWRvbmUuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/$$_gendir/app/auth/recover-password/recover-password-done/recover-password-done.component.css.shim.ngstyle.ts